<script setup>
import {
  ref, reactive, computed, onMounted, defineEmits,
} from 'vue';
import { useIncrementalDataField } from '@/composables/use-incremental-data-field';
import { useFieldValidation } from '@/composables/use-field-validation';
import { useStore } from 'vuex';

import ErrorMessage from '@/components/form/partials/error-message';
import TagSelector from '@/components/user-roles/src-alt';

const store = useStore();
const fieldName = 'jobRoles';
const validateAll = ref(true);
const jobRoles = computed(() => store.state.entities.jobRoles);
const selectedOptions = reactive({ jobRoles: [] });
const { validateStatus } = useFieldValidation();
const emit = defineEmits([]);

const getUserRolesFromRegistrationTags = (entitiesRoles) => {
  const entitiesRolesArray = Object.values(entitiesRoles)
    .reduce((acc, item) => {
      return acc.concat(item);
    }, []);

  return window.registrationTags.map((windowTag) => {
    return entitiesRolesArray.find((jobRole) => jobRole.slug === windowTag.tag_value);
  });
};

onMounted(() => {
  store.dispatch('entities/getJobRoles').then(() => {
    if (window.registrationTags === undefined) return;

    selectedOptions.jobRoles = getUserRolesFromRegistrationTags(jobRoles.value);
  });
});

const serverPayload = computed(() => ({
  jobRoles: selectedOptions.jobRoles.map((jobRole) => jobRole.slug),
}));

const {
  v$, submit,
} = useIncrementalDataField(fieldName, selectedOptions, serverPayload, emit);

defineExpose({
  submit,
  fields: {
    jobRoles: serverPayload,
  },
});

</script>

<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        Tell us a little more about your interests.
      </p>
      <div
        class="IncrementalData-question"
        data-rmpdev-selector="job-roles-field"
      >
        <label class="IncrementalData-questionText">
          What job roles are you interested in?
        </label>
        <div class="IncrementalData-questionField clearfix">
          <tag-selector
            v-model="selectedOptions.jobRoles"
            :available-tags="jobRoles"
            :is-searchable="true"
            :search-keys="['name']"
            modal-title="Select Jobs Roles"
            add-button-text="Add Jobs Roles"
            data-rmpdev-field-selector="jobRoles"
          />
          <error-message
            :manual-validate="validateAll"
            :errors="validateStatus({ field: v$.fields.jobRoles, serverKey: 'jobRoles', label: 'Job roles' }).errors"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
